
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    searchResults: {
        paddingBottom: '70px'
    },
    container: {
        borderTop: '1px solid transparent',
        borderBottom: 'transparent',
        background: '#ffffff'
    },
    innerContainer: {
        paddingTop: '24px'
    },
    sectionContainer: {
        marginLeft: '24px',
        marginRight: '24px'
    },
    sectionInnerContainer: {
        position: 'relative'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchResults/styles.js